import React from 'react';
import { Linkedin, MessageCircle } from 'lucide-react';
interface FooterProps {
  onTermsClick: () => void;
  onContactClick: () => void;
}
export const Footer = ({
  onTermsClick,
  onContactClick
}: FooterProps) => {
  return <footer className="bg-gray-50 text-gray-600 border-t border-gray-100" data-id="element-777">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-778">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-779">
          <div data-id="element-780">
            <h3 className="text-[#6366f1] text-xl font-bold mb-4" data-id="element-781">
              usegigi.ai
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-782">
              Your personal outreach assistant for modern businesses.
            </p>
          </div>
          <div data-id="element-783">
            <h4 className="text-gray-900 font-semibold mb-4" data-id="element-784">Legal</h4>
            <ul className="space-y-3" data-id="element-785">
              <li data-id="element-786">
                <button onClick={onTermsClick} className="hover:text-[#6366f1] transition-colors" data-id="element-787">
                  Terms of Service
                </button>
              </li>
              <li data-id="element-788">
                <a href="#" className="hover:text-[#6366f1] transition-colors" data-id="element-789">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-790">
                <a href="/investors" className="hover:text-[#6366f1] transition-colors" data-id="element-791">
                  Investors
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-792">
            <h4 className="text-gray-900 font-semibold mb-4" data-id="element-793">Connect</h4>
            <div className="flex space-x-4" data-id="element-794">
              <a href="https://www.linkedin.com/in/irina-stoicescu/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-xl bg-gray-100 text-gray-600 hover:bg-[#6366f1] hover:text-white transition-all duration-300" aria-label="LinkedIn Profile" data-id="element-795">
                <Linkedin size={20} data-id="element-796" />
              </a>
              <a href="https://wa.me/40736718154" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-xl bg-gray-100 text-gray-600 hover:bg-[#25D366] hover:text-white transition-all duration-300" aria-label="WhatsApp" data-id="element-797">
                <MessageCircle size={20} data-id="element-798" />
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200 mt-12 pt-8 text-sm text-center text-gray-500" data-id="element-799">
          © 2025 usegigi.ai. All rights reserved.
        </div>
      </div>
    </footer>;
};